
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZCarousel',
  props: {
    activeIndex: {
      default: 0,
      type: Number
    },
    indicatorPosition: {
      default: 'left',
      type: String
    },
    showIndicators: {
      default: true,
      type: Boolean
    },
    autoSlide: {
      default: true,
      type: Boolean
    },
    autoTiming: {
      default: '3000',
      type: String
    },
    showControls: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      currentIndex: this.activeIndex || 0,
      autoTimeout: null,
      slides: [],
      slideDirection: '',
      componentMounted: false
    }
  },
  computed: {
    slidesLength() {
      return this.slides.length
    },
    reachedMaxLeft() {
      return this.currentIndex === 0
    },
    getIndicatorPositionClass() {
      const positions = {
        left: 'justify-start',
        right: 'justify-end',
        center: 'justify-center'
      }
      return positions[this.indicatorPosition] || positions.left
    }
  },
  methods: {
    showNextSlide() {
      this.currentIndex++
      if (this.currentIndex >= this.slidesLength) {
        this.currentIndex = 0
      }
      this.slideDirection = 'slide-right'
      if (this.autoSlide) this.resetAutoSlide()
    },

    showPrevSlide() {
      this.currentIndex--
      if (this.currentIndex < 0) {
        this.currentIndex = this.slidesLength - 1
      }
      this.slideDirection = 'slide-left'
      if (this.autoSlide) this.resetAutoSlide()
    },

    showSlide(slideIndex) {
      if (slideIndex > this.currentIndex) this.slideDirection = 'slide-right'
      else this.slideDirection = 'slide-left'
      this.currentIndex = slideIndex
    },

    triggerAutoSlide() {
      this.autoTimeout = setTimeout(() => {
        this.showNextSlide()
      }, parseInt(this.autoTiming))
    },

    cancelAutoSlide() {
      clearTimeout(this.autoTimeout)
    },

    resetAutoSlide() {
      this.cancelAutoSlide()
      this.triggerAutoSlide()
    }
  },
  watch: {
    activeIndex() {
      this.showSlide(this.activeIndex)
    }
  },
  mounted() {
    this.slides = this.$children.filter((child) => child.$options.name === 'ZSlide')
    this.slides.forEach((slide, index) => {
      slide.index = index
    })
    if (this.autoSlide) this.triggerAutoSlide()
    this.componentMounted = true
  },
  beforeDestroy() {
    this.cancelAutoSlide()
  }
})
